// extracted by mini-css-extract-plugin
module.exports = {"titleStyle":"header_titleStyle__kXFO5","titleStyleSI":"header_titleStyleSI__l790N","dividerStick":"header_dividerStick__UCIg2"};